import {
  ORDER_STATUS_IN_PROGRESS,
  ORDER_STATUS_DELAYED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_CANCELLATION_IN_PROGRESS,
  ORDER_STATUS_COMMITTED,
  ORDER_STATUS_PROVISIONING,
  ORDER_STATUS_AWAITING_CREDIT_CHECK,
  ORDER_STATUS_AWAITING_ECC,
  ORDER_STATUS_PARTIALLY_CANCELLED,
} from 'features/order-tracker/services/constants';


export const ORDER_STATUSES = {
  [ORDER_STATUS_IN_PROGRESS]: ORDER_STATUS_IN_PROGRESS,
  [ORDER_STATUS_DELAYED]: ORDER_STATUS_DELAYED,
  [ORDER_STATUS_COMPLETED]: ORDER_STATUS_COMPLETED,
  [ORDER_STATUS_CANCELLED]: ORDER_STATUS_CANCELLED,
  [ORDER_STATUS_COMMITTED]: ORDER_STATUS_IN_PROGRESS,
  [ORDER_STATUS_CANCELLATION_IN_PROGRESS]: ORDER_STATUS_IN_PROGRESS,
  [ORDER_STATUS_PROVISIONING]: ORDER_STATUS_IN_PROGRESS,
  [ORDER_STATUS_AWAITING_ECC]: ORDER_STATUS_DELAYED,
  [ORDER_STATUS_AWAITING_CREDIT_CHECK]: ORDER_STATUS_IN_PROGRESS,
  [ORDER_STATUS_PARTIALLY_CANCELLED]: ORDER_STATUS_DELAYED,
};